module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "CT ParaOverride-8"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    staticClass: "TX-Italic _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/f005"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("•")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/f005"
    }
  }, [_vm._v("The Great Transition")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_c('a', {
    attrs: {
      "href": "#/f006"
    }
  }, [_vm._v("chapter one")])]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("•")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/f006"
    }
  }, [_vm._v("The Harbinger")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_c('a', {
    attrs: {
      "href": "#/f007"
    }
  }, [_vm._v("chapter two")])]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("•")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/f007"
    }
  }, [_vm._v("The Exponential Age")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_c('span', {
    attrs: {
      "href": "#/f008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter three")])]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/f008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Exponential Gap")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_c('span', {
    attrs: {
      "href": "#/f009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter four")])]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/f009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unlimited Company")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_c('span', {
    attrs: {
      "href": "#/f010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter five")])]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/f010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Labor’s Loves Lost")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_c('span', {
    attrs: {
      "href": "#/f011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter six")])]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/f011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World is Spiky")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_c('span', {
    attrs: {
      "href": "#/f012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter seven")])]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/f012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New World Disorder")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_c('span', {
    attrs: {
      "href": "#/f013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter eight")])]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/f013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exponential Citizens")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC ParaOverride-9"
  }, [_c('span', {
    staticClass: "TX-Italic _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/f014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/f014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abundance and Equity")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    staticClass: "TX-Italic _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/f015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    staticClass: "TX-Italic _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/f016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    staticClass: "TX-Italic _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/f017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    staticClass: "TX-Italic _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/f018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9e7ca36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/f004.vue
// module id = 69
// module chunks = 0